interface Config {
  API_URL: string;
  ENV: string;
}

const config: Config = {
  API_URL: process.env.REACT_APP_ENV === 'production'
    ? (process.env.REACT_APP_PYTHON_API_URL || 'https://default-api-url.com')
    : 'http://localhost:5000',
    // API_URL: process.env.PYTHON_APP_API_URL || 'http://localhost:5000',
  ENV: process.env.REACT_APP_ENV || 'development'
};

export default config; 